import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Modal } from '../common/components';
import translations from './useLocks.translations.json';
import { LockResponse } from './query/useLockQuery';
import { useCallback } from 'react';
import { getUserName } from '../user';

const { addTranslations, t } = i18nNsFactory('use-locks');
addTranslations(translations);

function checkLockAndNavigate(
  refetch: () => any,
  data: LockResponse | undefined,
  navigate: () => void,
) {
  refetch().then((res: any) => {
    if (!res.data || (res.data.lock && !res.data.owner)) {
      Modal.info({
        title: t('error.title'),
        content: t(`error.object_locked`, {
          user: data?.lock ? getUserName(data.lock) : '',
        }),
      });
    } else {
      navigate();
    }
  });
}

export const useCheckLockAndNavigate = (
  refetchArg: () => any,
  dataArg: LockResponse | undefined,
  navigateArg: () => void,
) => {
  return useCallback(
    (refetch = refetchArg, data = dataArg, navigate = navigateArg) =>
      checkLockAndNavigate(refetch, data, navigate),
    [refetchArg, dataArg, navigateArg],
  );
};
